import { isNil } from 'ramda';
import { Union } from 'ts-toolbelt';

export const toNumber = (value: Union.Nullable<any>): number | null => {
  if (isNil(value)) {
    return null;
  }
  return Number(value);
};
